import api from "./api";

export default {
  // Obtener todas las imágenes
  async getImages(search = "", category = "", isActive = true) {
    try {
      const params = new URLSearchParams();
      if (search) params.append("search", search);
      if (category) params.append("category", category);
      if (isActive !== undefined) params.append("isActive", isActive);

      const response = await api.get(`/images?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching images:", error);
      throw error;
    }
  },

  // Obtener imágenes paginadas (para el ABM de prácticas)
  async getImagesPaginated({
    search = "",
    category = "",
    isActive,
    offset = 0,
    limit = 50,
  } = {}) {
    try {
      const response = await api.get("/images", {
        params: { search, category, isActive, offset, limit, paginate: true },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching paginated images:", error);
      throw error;
    }
  },

  // Obtener todas las categorías
  async getCategories() {
    try {
      const response = await api.get("/images/categories");
      return response.data;
    } catch (error) {
      console.error("Error fetching categories:", error);
      console.error("Error details:", error.response?.data || error.message);
      throw error;
    }
  },

  // Obtener una imagen específica
  async getImage(id) {
    try {
      const response = await api.get(`/images/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching image:", error);
      throw error;
    }
  },

  // Crear una nueva imagen
  async createImage(imageData) {
    try {
      const response = await api.post("/images", imageData);
      return response.data;
    } catch (error) {
      console.error("Error creating image:", error);
      throw error;
    }
  },

  // Actualizar una imagen
  async updateImage(id, imageData) {
    try {
      const response = await api.put(`/images/${id}`, imageData);
      return response.data;
    } catch (error) {
      console.error("Error updating image:", error);
      throw error;
    }
  },

  // Eliminar una imagen
  async deleteImage(id) {
    try {
      const response = await api.delete(`/images/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting image:", error);
      throw error;
    }
  },
};
